import { render, staticRenderFns } from "./MarketCustomer.vue?vue&type=template&id=c76a20c6&scoped=true"
import script from "./MarketCustomer.vue?vue&type=script&lang=js"
export * from "./MarketCustomer.vue?vue&type=script&lang=js"
import style0 from "./MarketCustomer.vue?vue&type=style&index=0&id=c76a20c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76a20c6",
  null
  
)

export default component.exports